<template>
	<v-row align="center" justify="center">
		<v-col>
			<user-forgot-password-form></user-forgot-password-form>
			<br />
			<p align="center" class="white--text">
				Have an account?
				<router-link to="/" class="white--text">Sign In</router-link>
			</p>
		</v-col>
	</v-row>
</template>

<script>
import UserForgotPasswordForm from '@/components/user/UserForgotPasswordForm.vue';

export default {
	name: 'ForgotPassword',
	components: {
		UserForgotPasswordForm,
	},
	data: () => ({
		apiRequest: false,
	}),
	methods: {},
};
</script>
